<!--2020/05/25 lqz-->
<template>
  <div>
    <div
      class="ccui-home-index"
      v-if="emcGoodsNumAndCar > 0 && flagIsNoContent"
    >
      <div class="emc-container">
        <!--购物车模块01Begin-->
        <div style="width: 100%">
          <div class="emc-top clearfix row">
            <div class="emc-title">商城商品({{ emcGoodsNumAndCar }})</div>
            <div
              class="emc-title-no-active"
              @click="goInquiryPricePage"
              style="margin-left: 15px;"
            >
              询价商品
            </div>
            <div class="flex">
              <UnitSelect
                :purchaseUndertakeOrgIdTreeData="unitSelectData"
                :purchaseOrgId="purchaseOrgId"
                :purchaseUndertakeOrgIdValue="purchaseUndertakeOrgIdValue"
              />
              <div class="emc-select-address">
                <label>配送至：</label>
                <el-area-selector
                  style="width: 330px"
                  :defaultArea="defaultAreaFix"
                  @getAddressOf="getAddressOf"
                  :place="leftPlace"
                  :url="getAddressUrl"
                  :headers="{ Authorization: this.access_token || '' }"
                  :agentId="paramsData"
                  v-if="!isAddressOne"
                ></el-area-selector>
              </div>
            </div>
          </div>
        </div>
        <!--购物车模块01End-->
        <div :style="{ 'min-height': minHeight }">
          <!--购物车交互Begin-->
          <ul class="emc-table-head">
            <li :style="{ width: tableWidth.selection + 40 + 'px' }">
              <label style="cursor: pointer" class="emc-checkbox-lable">
                <el-checkbox
                  class="emc-checkbox"
                  style="padding-right: 13px"
                  :indeterminate="checkedEmcAll.isIndeterminate['isIndeter']"
                  v-model="checkedEmcAll.selectedData['isChecked']"
                  @change="handleCheckAllEmcChange"
                ></el-checkbox>
                全选
              </label>
              <span class="disabledFixCheckbox" v-if="!isCheckedState"></span>
            </li>
            <li :style="{ width: tableWidth.goodsName1 - 40 + 'px' }">商品</li>
            <li :style="{ width: tableWidth.invoiceSubject - 40 + 'px' }">
              开票主体
            </li>
            <li
              :style="{
                width: tableWidth.goodsPrice - 10 + 'px',
                'padding-right': '10px',
                'text-align': 'right'
              }"
            >
              单价
            </li>
            <li
              :style="{
                width: tableWidth.goodsNum + 'px',
                'text-align': 'center'
              }"
            >
              数量
            </li>
            <li
              :style="{
                width: tableWidth.goodsTotal - 30 + 'px',
                'padding-right': '10px',
                'text-align': 'right'
              }"
            >
              税率
            </li>
            <li
              :style="{
                width: tableWidth.goodsTotal - 10 + 'px',
                'text-align': 'right',
                'padding-right': '10px'
              }"
            >
              小计
            </li>
            <li
              :style="{
                width: tableWidth.op - 10 + 'px',
                'padding-left': '10px'
              }"
            >
              操作
            </li>
          </ul>

          <!--以店铺为基石 大循环Begin---------------------------------------------------------------------------->
          <div
            class="emc-goods-table"
            v-for="(item1, index1) of emcGoodsListData"
            :key="index1"
          >
            <!--判断第一级是否是店铺Begin-->
            <div class="emc-shop-goods-table" v-if="item1.type === 2">
              <ul class="emc-shop-goods-table-head">
                <li :style="{ width: tableWidth.selection + 'px' }">
                  <el-checkbox
                    class="emc-checkbox"
                    :indeterminate="
                      checkedShopAll.isIndeterminate[`${item1.code}`]
                    "
                    v-model="checkedShopAll.selectedData[`${item1.code}`]"
                    :disabled="item1.shopdisabled"
                    @change="
                      val => {
                        handleCheckAllShopChange(val, item1.code);
                      }
                    "
                  ></el-checkbox>
                  <span
                    class="disabledFixCheckbox"
                    v-if="!isCheckedState"
                  ></span>
                </li>
                <li :style="{ width: tableWidth.goodsName1 - 40 + 'px' }">
                  <!-- 店铺： -->
                  <i
                    class="icon-shopingName"
                    v-if="item1.shopType && getShopName(item1.shopType)"
                    >{{ getShopName(item1.shopType) }}</i
                  >
                  <a
                    :title="item1.name"
                    class="shopName"
                    v-if="item1.status === 1"
                    :href="VUE_APP_EMS_URL + 'notShop'"
                    target="_blank"
                    >{{ item1.name }}</a
                  >
                  <a
                    :title="item1.name"
                    class="shopName"
                    v-else
                    :href="VUE_APP_EMS_URL + '?shopId=' + item1.secretShopCode"
                    target="_blank"
                    >{{ item1.name }}</a
                  >
                </li>
                <li>
                  <span style="float:left">开票主体：</span
                  ><span :title="item1.businessName" class="invoiceSubject">{{
                    item1.businessName
                  }}</span
                  ><i
                    @click="copyInvoiceSubject(item1)"
                    class="icon-ccui-copy"
                    style="color:#0089EF;margin-left:10px;cursor: pointer;"
                  ></i>
                </li>
              </ul>
              <div class="emc-shop-goods-table-content">
                <el-checkbox-group
                  v-model="checkedForm.selectedData[`${item1.code}`]"
                >
                  <div v-for="(item2, index2) of item1.sons" :key="index2">
                    <!--无活动Begin--->
                    <div v-if="item2.type === 3" class="goods-shop-unactivity">
                      <ul
                        :class="[
                          checkedForm.selectedData[item1.code].indexOf(
                            item2.code
                          ) > -1
                            ? 'goods-shop-list active'
                            : 'goods-shop-list'
                        ]"
                      >
                        <li :style="{ width: tableWidth.selection + 'px' }">
                          <el-checkbox
                            :label="item2.code"
                            :key="item2.code"
                            :disabled="isdisabled(item2.skuStatus)"
                            class="emc-checkbox"
                            @change="
                              val => {
                                handleCheckedGoodsChange(
                                  val,
                                  item1.code,
                                  item2.code
                                );
                              }
                            "
                          ></el-checkbox>
                          <span class="line-circle"></span>
                          <span class="item-line"></span>
                          <span
                            class="disabledFixCheckbox"
                            v-if="!isCheckedState"
                          ></span>
                        </li>
                        <li :style="{ width: tableWidth.goodsName + 'px' }">
                          <!--商品Begin-->
                          <div class="goods-detail clearfix">
                            <div
                              class="goods-detail-state"
                              :style="
                                Number(item2.skuStatus) === 10
                                  ? 'width: 30px'
                                  : ''
                              "
                            >
                              {{
                                item2.skuStatus | toSkuStatusStr([1, 5, 7, 8])
                              }}
                            </div>
                            <a
                              :href="goodsDetailUrl + item2.code"
                              target="_blank"
                            >
                              <img
                                class="goods-img"
                                :src="item2.picUrl | goodsPicFormat"
                            /></a>
                            <p class="goods-name">
                              <a
                                :href="goodsDetailUrl + item2.code"
                                target="_blank"
                                :title="item2.name"
                              >
                                <span>{{ item2.name }}</span>
                              </a>
                            </p>
                            <div
                              style="padding-left: 110px; padding-top: 6px;display: flex"
                            >
                              <Tag
                                :labelItem="getLableItem(item2)"
                                :shopType="item1.shopType"
                                :contractType="item2.contractType"
                              />
                              <!-- <span class="low-price-label" v-if="item2.isLower"
                              >同款最低价</span
                            > -->
                            </div>
                          </div>
                          <div
                            class="goods-other"
                            v-if="item2.queryEmcGiftDetailBOS.length > 0"
                          >
                            <p
                              v-for="(itemGift,
                              indexGift) of item2.queryEmcGiftDetailBOS"
                              :key="indexGift"
                            >
                              【赠品】{{ itemGift.giftName }}... x{{
                                itemGift.num
                              }}
                            </p>
                          </div>
                          <div class="goods-dividing-line"></div>
                          <div
                            style="font-size: 12px;margin: 10px 0 0 36px;"
                            v-if="getLowerStatus(item2)"
                          >
                            <span style="color:#898989;"
                              >【温馨提示】经平台比价后，有更低价商品</span
                            >
                            <span
                              @click="showModal(item2.code)"
                              style="color:#FF142F;margin-left: 10px;cursor: pointer;"
                              >查看低价商品</span
                            >
                          </div>
                          <!--商品End-->
                        </li>
                        <li
                          :style="{
                            width: tableWidth.goodsPrice - 10 + 'px',
                            'padding-right': '10px',
                            'text-align': 'right'
                          }"
                        >
                          <p class="goods-price">
                            <span v-if="Number(item2.skuStatus) == 10"
                              >******</span
                            >
                            <span v-else>
                              ￥ {{ item2.salePrice | toMoneyFormat }}
                            </span>
                          </p>
                          <p
                            class="goods-attribute"
                            v-if="
                              item2.downPrice &&
                                item2.isReducePrice &&
                                item2.skuStatus !== 10
                            "
                          >
                            <span>
                              降价：￥{{ item2.downPrice | toMoneyFormat }}
                            </span>
                          </p>
                          <p class="goods-price-select" style="display: none">
                            <!--暂无促销模型-->
                            <span class="promotion"
                              ><div class="goods-price-select-title">
                                促销<i class="icon-ccui-down"></i>
                              </div>
                              <div class="goods-price-select-box">
                                <ul>
                                  <li></li>
                                </ul>
                              </div>
                            </span>
                          </p>
                          <p
                            class="goods-price-select"
                            v-if="
                              item2.ladderPrice &&
                                item2.skuStatus !== 10 &&
                                item2.flag != 2
                            "
                          >
                            <!--是否阶梯价-->
                            <span class="set-price"
                              ><div class="goods-price-select-title">
                                阶梯价<i class="icon-ccui-down"></i>
                              </div>
                              <div class="goods-price-select-box">
                                <ul>
                                  <li>
                                    <table>
                                      <tbody>
                                        <tr
                                          v-for="(itemLadder,
                                          indexLaddeer) of item2.ladderPriceBOS"
                                          :key="indexLaddeer"
                                          :class="[
                                            Number(item2.num) >=
                                              Number(itemLadder.downString) &&
                                            Number(item2.num) <=
                                              Number(
                                                itemLadder.upString || 100000
                                              )
                                              ? 'active'
                                              : ''
                                          ]"
                                        >
                                          <td
                                            v-if="itemLadder.upString"
                                            style="text-align: right"
                                          >
                                            {{ itemLadder.downString }}-{{
                                              itemLadder.upString
                                            }}{{ item2.unitName }}：
                                          </td>
                                          <td v-else style="text-align: right">
                                            ≥{{ itemLadder.downString
                                            }}{{ item2.unitName }}：
                                          </td>
                                          <td>
                                            ¥{{
                                              itemLadder.salePrice
                                                | toMoneyFormat
                                            }}
                                          </td>
                                        </tr>
                                        <tr></tr>
                                      </tbody>
                                    </table>
                                  </li>
                                </ul>
                              </div>
                            </span>
                          </p>
                        </li>
                        <li
                          :style="{
                            width: tableWidth.goodsNum + 'px',
                            'text-align': 'center'
                          }"
                        >
                          <div>
                            <el-input-number
                              v-model="objAllNum[item2.code]"
                              debounce
                              @focus="focusGoodsNum()"
                              @blur="blurGoodsNum"
                              @change="
                                value => {
                                  handleChangeGoodsNum(
                                    value,
                                    item2,
                                    item1.code
                                  );
                                }
                              "
                              :min="item2.minPurchaseNum || 1"
                              label=""
                            ></el-input-number>
                            <div class="stockTip">
                              <span
                                v-if="
                                  item2.minPurchaseNum &&
                                    parseInt(item2.minPurchaseNum) > 1
                                "
                                class="pr-5"
                                >起订量：{{ item2.minPurchaseNum }}
                              </span>
                              <span
                                class="highlight"
                                v-if="
                                  item2.skuStatus !== 1 && item2.skuStatus !== 7
                                "
                                >{{
                                  item2.skuStatus
                                    | toSkuStatusStr([2, 3, 4, 6, 7, 8])
                                }}</span
                              >
                              <span v-else>{{
                                item2.skuStatus
                                  | toSkuStatusStr([2, 3, 4, 6, 7, 8])
                              }}</span>
                            </div>
                          </div>
                        </li>
                        <li
                          :style="{
                            width: tableWidth.goodsTotal - 30 + 'px',
                            'text-align': 'right',
                            'padding-right': '10px'
                          }"
                        >
                          <div class="goods-curr-total">
                            <div>
                              {{ item2.taxInfo
                              }}{{ item2.taxInfo == "免税" ? "" : "%" }}
                            </div>
                          </div>
                        </li>
                        <li
                          :style="{
                            width: tableWidth.goodsTotal - 10 + 'px',
                            'text-align': 'right',
                            'padding-right': '10px'
                          }"
                        >
                          <div class="goods-curr-total">
                            <div v-if="Number(item2.skuStatus) == 10">
                              ******
                            </div>
                            <div v-else>
                              ￥{{ item2.total | toMoneyFormat }}
                            </div>
                            <!--div
                          class="goods-curr-total-discount"
                          v-if="item2.downPrice"
                        >
                          减￥{{ item2.downPrice | toMoneyFormat }}
                        </div-->
                            <!--div v-if="item2.downPrice">
                          ￥{{
                            (item2.total - item2.downPrice) | toMoneyFormat
                          }}
                        </div-->
                          </div>
                        </li>
                        <li
                          :style="{
                            width: tableWidth.op - 10 + 'px',
                            'padding-left': '10px'
                          }"
                        >
                          <a
                            href="javascript:;"
                            class="deletedCurr"
                            @click="deletedCurr(item2, item1)"
                            >删除</a
                          >
                          <span
                            href="javascript:;"
                            class="removeCurr"
                            @click="removeCurr(item2)"
                            >移到我的关注</span
                          >
                        </li>
                      </ul>
                    </div>
                    <!--无活动End-->
                    <!--有活动Begin-->
                    <div v-if="item2.type === 1" class="goods-shop-activity">
                      <div class="goods-shop-activity-head">
                        <span>满减</span>{{ item2.name }}>
                        <a href="javascript:;">去凑单</a>
                        <p class="goods-shop-totalprice">
                          ￥{{ item2.totalSelectedPrice | toMoneyFormat }}
                        </p>
                        <p class="goods-shop-totaldisprice">
                          减￥{{ item2.minusPrice | toMoneyFormat }}
                        </p>
                      </div>
                      <div class="goods-shop-activity-list">
                        <ul
                          v-for="(item3, index3) of item2.sons"
                          :key="index3"
                          :class="[
                            checkedForm.selectedData[item1.code].indexOf(
                              item3.code
                            ) > -1
                              ? 'goods-shop-list active'
                              : 'goods-shop-list'
                          ]"
                        >
                          <li :style="{ width: tableWidth.selection + 'px' }">
                            <el-checkbox
                              :label="item3.code"
                              :key="item3.code"
                              :disabled="isdisabled(item3.skuStatus)"
                              class="emc-checkbox"
                              @change="
                                val => {
                                  handleCheckedGoodsChange(
                                    val,
                                    item1.code,
                                    item3.code
                                  );
                                }
                              "
                            ></el-checkbox>
                            <span class="line-circle"></span>
                            <span class="item-line"></span>
                            <span
                              class="disabledFixCheckbox"
                              v-if="!isCheckedState"
                            ></span>
                          </li>
                          <li :style="{ width: tableWidth.goodsName + 'px' }">
                            <!--商品Begin-->
                            <div class="goods-detail clearfix">
                              <div
                                class="goods-detail-state"
                                :style="
                                  Number(item3.skuStatus) === 10
                                    ? 'width: 30px'
                                    : ''
                                "
                              >
                                {{
                                  item3.skuStatus | toSkuStatusStr([1, 5, 7, 8])
                                }}
                              </div>
                              <a
                                :href="goodsDetailUrl + item2.code"
                                target="_blank"
                              >
                                <img
                                  class="goods-img"
                                  :src="item3.picUrl | goodsPicFormat"
                                />
                              </a>
                              <p class="goods-name">
                                <a
                                  :href="goodsDetailUrl + item2.code"
                                  target="_blank"
                                  :title="item3.name"
                                >
                                  <span>{{ item3.name }}</span>
                                </a>
                              </p>
                            </div>
                            <div
                              class="goods-other"
                              v-if="item3.queryEmcGiftDetailBOS.length > 0"
                            >
                              <p
                                v-for="(itemGift,
                                indexGift) of item3.queryEmcGiftDetailBOS"
                                :key="indexGift"
                              >
                                【赠品】{{ itemGift.giftName }}... x{{
                                  itemGift.num
                                }}
                              </p>
                            </div>
                            <div class="goods-dividing-line"></div>
                            <!--商品End-->
                          </li>
                          <li
                            :style="{
                              width: tableWidth.goodsPrice - 10 + 'px',
                              'padding-right': '10px',
                              'text-align': 'right'
                            }"
                          >
                            <p class="goods-price">
                              <span v-if="Number(item3.skuStatus) == 10"
                                >******</span
                              >
                              <span v-else>
                                ￥ {{ item3.salePrice | toMoneyFormat }}
                              </span>
                            </p>
                            <p class="goods-attribute" v-if="item3.downPrice">
                              <span
                                v-if="
                                  item2.isReducePrice && item2.skuStatus !== 10
                                "
                              >
                                降价：￥{{ item3.downPrice | toMoneyFormat }}
                              </span>
                            </p>
                            <p class="goods-price-select" style="display: none">
                              <!--暂无促销模型-->
                              <span class="promotion"
                                ><div class="goods-price-select-title">
                                  促销<i class="icon-ccui-down"></i>
                                </div>
                                <div class="goods-price-select-box">
                                  <ul>
                                    <li></li>
                                  </ul>
                                </div>
                              </span>
                            </p>
                            <p
                              class="goods-price-select"
                              v-if="
                                item3.ladderPrice &&
                                  item3.skuStatus !== 10 &&
                                  item3.flag != 2
                              "
                            >
                              <!--是否阶梯价-->
                              <span class="set-price"
                                ><div class="goods-price-select-title">
                                  阶梯价<i class="icon-ccui-down"></i>
                                </div>
                                <div class="goods-price-select-box">
                                  <ul>
                                    <li>
                                      <table>
                                        <tbody>
                                          <tr
                                            v-for="(itemLadder,
                                            indexLaddeer) of item2.ladderPriceBOS"
                                            :key="indexLaddeer"
                                            :class="[
                                              Number(item2.num) >=
                                                Number(itemLadder.downString) &&
                                              Number(item2.num) <
                                                Number(itemLadder.upString)
                                                ? 'active'
                                                : ''
                                            ]"
                                          >
                                            <td
                                              v-if="itemLadder.upString"
                                              style="text-align: right"
                                            >
                                              {{ itemLadder.downString }}-{{
                                                itemLadder.upString
                                              }}{{ item2.unitName }}：
                                            </td>
                                            <td
                                              v-else
                                              style="text-align: right"
                                            >
                                              ≥{{ itemLadder.downString
                                              }}{{ item2.unitName }}：
                                            </td>
                                            <td>
                                              ¥{{
                                                itemLadder.salePrice
                                                  | toMoneyFormat
                                              }}
                                            </td>
                                          </tr>
                                          <tr></tr>
                                        </tbody>
                                      </table>
                                    </li>
                                  </ul>
                                </div>
                              </span>
                            </p>
                          </li>
                          <li
                            :style="{
                              width: tableWidth.goodsNum + 'px',
                              'text-align': 'center'
                            }"
                          >
                            <div>
                              <el-input-number
                                v-model="objAllNum[item3.code]"
                                debounce
                                @focus="focusGoodsNum()"
                                @blur="blurGoodsNum"
                                @change="
                                  value => {
                                    handleChangeGoodsNum(
                                      value,
                                      item3,
                                      item2.code
                                    );
                                  }
                                "
                                :min="item3.minPurchaseNum || 1"
                                label=""
                              ></el-input-number>
                              <div class="stockTip">
                                <span
                                  v-if="
                                    item3.minPurchaseNum &&
                                      parseInt(item3.minPurchaseNum) > 1
                                  "
                                  class="pr-5"
                                  >起订量：{{ item3.minPurchaseNum }}
                                </span>
                                <span
                                  class="highlight"
                                  v-if="
                                    item3.skuStatus !== 1 &&
                                      item3.skuStatus !== 7
                                  "
                                  >{{
                                    item3.skuStatus
                                      | toSkuStatusStr([2, 3, 4, 6, 7, 8])
                                  }}</span
                                >
                                <span v-else>{{
                                  item3.skuStatus
                                    | toSkuStatusStr([2, 3, 4, 6, 7, 8])
                                }}</span>
                              </div>
                            </div>
                          </li>
                          <li
                            :style="{
                              width: tableWidth.goodsTotal - 30 + 'px',
                              'text-align': 'right',
                              'padding-right': '10px'
                            }"
                          >
                            <div class="goods-curr-total">
                              <div>
                                {{ item3.taxInfo
                                }}{{ item3.taxInfo == "免税" ? "" : "%" }}
                              </div>
                            </div>
                          </li>
                          <li
                            :style="{
                              width: tableWidth.goodsTotal - 10 + 'px',
                              'text-align': 'right',
                              'padding-right': '10px'
                            }"
                          >
                            <div class="goods-curr-total">
                              <div v-if="Number(item2.skuStatus) == 10">
                                ******
                              </div>
                              <div v-else>
                                ￥{{ item3.total | toMoneyFormat }}
                              </div>
                              <!--div
                            class="goods-curr-total-discount"
                            v-if="item3.downPrice"
                          >
                            减￥{{ item3.downPrice | toMoneyFormat }}
                          </div-->
                              <!--div v-if="item3.downPrice">
                            ￥{{
                              (item3.total - item3.downPrice) | toMoneyFormat
                            }}
                          </div-->
                            </div>
                          </li>
                          <li
                            :style="{
                              width: tableWidth.op - 10 + 'px',
                              'padding-left': '10px'
                            }"
                          >
                            <a
                              href="javascript:;"
                              class="deletedCurr"
                              @click="deletedCurr(item3, item2)"
                              >删除</a
                            >
                            <span
                              href="javascript:;"
                              class="removeCurr"
                              @click="removeCurr(item3)"
                              >移到我的关注</span
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!--有活动End-->
                  </div>
                </el-checkbox-group>
              </div>
            </div>
            <!--判断第一级是否是店铺End-->
            <!--判断第一级是活动Begin 咱无第一级是活动情况-->
            <!--判断第一级是活动End-->
          </div>
          <!--大循环End---------------------------------------------------------------------------->

          <!--车辆租赁商品-->
          <div class="emc-car-goods-table" v-if="carList.length > 0">
            <ul class="emc-car-goods-table-head">
              <li :style="{ width: tableWidth.selection + 'px' }">
                <el-checkbox
                  :value="selectAllCar"
                  :indeterminate="allCarIndeterminate"
                  @change="changeAllCar"
                  class="emc-checkbox"
                ></el-checkbox>
              </li>
              <li :style="{ width: tableWidth.goodsName1 - 40 + 'px' }">
                车辆租赁
              </li>
            </ul>
            <ul
              class="goods-shop-list"
              :class="{ active: item.selected }"
              v-for="(item, $index) of carList"
              :key="$index"
            >
              <li :style="{ width: tableWidth.selection + 'px' }">
                <el-checkbox
                  class="emc-checkbox"
                  v-model="item.selected"
                  @change="changeCar($event, item, $index)"
                  :true-label="1"
                  :false-label="0"
                  :disabled="item.isAvailable == 0"
                ></el-checkbox>
              </li>
              <li :style="{ width: tableWidth.goodsName + 'px' }">
                <!--商品Begin-->
                <div class="goods-detail clearfix">
                  <div class="goods-detail-state">
                    <span v-if="item.isAvailable == 0">下架</span>
                  </div>
                  <img class="goods-img" :src="item.img | goodsPicFormatCar" />
                  <!--<p class="goods-name" :title="item.name" >
                  <span>{{ item.name }}</span>
              </p>-->

                  <p
                    class="goods-name"
                    :title="item.brandName + ' - ' + item.carModelName"
                  >
                    <span class="goods-name-link" @click="goCarDetail(item)">{{
                      item.brandName + " - " + item.carModelName
                    }}</span>
                  </p>
                  <div style="padding-left: 112px;margin-top: 6px;">
                    <span>租期：{{ item.rentalDurationMonths }}个月</span>
                    <span style="margin-left: 20px;"
                      >取车城市：{{ item.cityName }}</span
                    >
                  </div>
                </div>
                <div class="goods-dividing-line"></div>
                <!--商品End-->
              </li>
              <li
                :style="{
                  width: tableWidth.goodsPrice - 10 + 'px',
                  'padding-right': '10px',
                  'text-align': 'right'
                }"
              >
                <p class="good-default">
                  <span>￥ {{ item.price | toMoneyFormat }}/月</span>
                </p>
              </li>
              <li
                :style="{
                  width: tableWidth.goodsNum + 'px',
                  'text-align': 'center'
                }"
              >
                <div>
                  <el-input-number
                    v-model="item.rentalNum"
                    @change="updateCarCart($event, item, $index)"
                    debounce
                    :min="1"
                    :max="999"
                  ></el-input-number>
                </div>
                <div class="stockTip">
                  <div v-if="item.isAvailable == 1">有货</div>
                  <div v-if="item.isAvailable == 0" class="highlight">下架</div>
                </div>
              </li>
              <li
                :style="{
                  width: tableWidth.goodsTotal - 30 + 'px',
                  'text-align': 'right',
                  'padding-right': '10px'
                }"
              >
                <div class="good-default">
                  <div>
                    {{ item.taxInfo }}{{ item.taxInfo == "免税" ? "" : "%" }}
                  </div>
                </div>
              </li>
              <li
                :style="{
                  width: tableWidth.goodsTotal - 10 + 'px',
                  'text-align': 'right',
                  'padding-right': '10px'
                }"
              >
                <div class="good-default">
                  <div>￥{{ item.totalAmount | toMoneyFormat }}</div>
                </div>
              </li>
              <li
                :style="{
                  width: tableWidth.op - 10 + 'px',
                  'padding-left': '10px'
                }"
              >
                <a
                  href="javascript:;"
                  class="deletedCurr"
                  @click="deletedCar(item)"
                  >删除</a
                >
              </li>
            </ul>
          </div>

          <!--已下架的商品-->
          <div class="emc-shop-goods-undercarriage-table">
            <ul
              class="goods-shop-list"
              v-for="(item, $index) of invalidGoodsListData"
              :key="$index"
            >
              <li :style="{ width: tableWidth.selection + 'px' }"></li>
              <li :style="{ width: tableWidth.goodsName + 'px' }">
                <!--商品Begin-->
                <div class="goods-detail clearfix">
                  <div
                    class="goods-detail-state"
                    :style="Number(item.skuStatus) == 10 ? 'width: 30px' : ''"
                  >
                    {{ item.skuStatus | toSkuStatusStr() }}
                  </div>
                  <img class="goods-img" :src="item.picUrl | goodsPicFormat" />
                  <!--<p class="goods-name" :title="item.name" >
                  <span>{{ item.name }}</span>
              </p>-->

                  <p class="goods-name" :title="item.name">
                    <span>{{ item.name }}</span>
                  </p>
                </div>
                <div class="goods-dividing-line"></div>
                <!--商品End-->
              </li>
              <li
                :style="{
                  width: tableWidth.goodsPrice - 10 + 'px',
                  'padding-right': '10px',
                  'text-align': 'right'
                }"
              >
                <p class="good-default">
                  <span v-if="Number(item.skuTwoStatus) == 10">******</span>
                  <span v-else>￥ {{ item.salePrice | toMoneyFormat }}</span>
                </p>
              </li>
              <li
                :style="{
                  width: tableWidth.goodsNum + 'px',
                  'text-align': 'center'
                }"
              >
                <div>
                  <div class="good-default">
                    {{ item.num }}
                  </div>
                </div>
              </li>
              <li
                :style="{
                  width: tableWidth.goodsTotal - 30 + 'px',
                  'text-align': 'center'
                }"
              >
                <div>
                  <div class="good-default">
                    {{ item.taxInfo }}{{ item.taxInfo == "免税" ? "" : "%" }}
                  </div>
                </div>
              </li>
              <li
                :style="{
                  width: tableWidth.goodsTotal - 10 + 'px',
                  'text-align': 'right',
                  'padding-right': '10px'
                }"
              >
                <div class="good-default">
                  <div v-if="Number(item.skuTwoStatus) == 10">******</div>
                  <div v-else>￥{{ item.total | toMoneyFormat }}</div>
                </div>
              </li>
              <li
                :style="{
                  width: tableWidth.op - 10 + 'px',
                  'padding-left': '10px'
                }"
              >
                <a
                  href="javascript:;"
                  class="deletedCurr"
                  @click="deletedCurr(item)"
                  >删除</a
                >
                <span
                  href="javascript:;"
                  class="removeCurr"
                  @click="removeCurr(item)"
                  >移到我的关注</span
                >
              </li>
            </ul>
          </div>

          <!--购物车交互End-->
        </div>

        <!--加载状态和没有更多数据提示-->
        <!-- <div class="load-more-container" v-if="emcGoodsNumAndCar > 0">
        <div
          class="loading-indicator"
          :style="pageLoading ? 'height:80px' : ''"
          v-loading="pageLoading"
          element-loading-text="奋力加载中"
        ></div>
        <div v-if="noMoreData" class="no-more-data">
          <span>没有更多数据了</span>
        </div>
      </div> -->

        <!--总合Begin-->
        <div class="emc-all-total" id="emc-all-total">
          <div class="emc-all-total-l clearfix">
            <label>
              <el-checkbox
                class="emc-checkbox"
                style="padding-right: 19px"
                :indeterminate="checkedEmcAll.isIndeterminate['isIndeter']"
                v-model="checkedEmcAll.selectedData['isChecked']"
                @change="handleCheckAllEmcChange"
              ></el-checkbox>
              全选
            </label>
            <span class="disabledFixCheckbox" v-if="!isCheckedState"></span>
            <a href="javascript:;" @click="deletedEmcGoods()">删除选中商品</a>
            <a href="javascript:;" @click="removeEmcGoods()">移到我的关注</a>
          </div>
          <div class="emc-all-total-r clearfix">
            <div class="emc-all-total-r-slected">
              已选商品<span>{{ selectGoodsNumAndCar }}</span
              >种
            </div>
            <div class="emc-all-total-r-slected-title">
              <span class="emc-all-total-r-slected-title-h2"
                >总计（不含运费）</span
              ><span class="emc-all-total-r-slected-title-p"
                >￥{{ selectGoodsTotalPriceAndCar | toMoneyFormat }}</span
              >
              <div
                v-if="selectemcGoodsTotalDisPrice"
                class="emc-all-total-r-slected-attr"
              >
                促销：-￥{{ selectemcGoodsTotalDisPrice | toMoneyFormat }}
              </div>
            </div>
            <template v-if="isHasSeekPermission">
              <!-- <a
                v-if="!hasSeek"
                href="javascript:;"
                class="emc-all-submit-order"
                @click="initiateInquiry"
                >发起比价</a
              >
              <a
                v-else
                href="javascript:;"
                class="emc-all-submit-order"
                @click="viewSourceOrder"
                >查看寻源单</a
              > -->
              <a
                v-if="hasSeek"
                href="javascript:;"
                class="bijia-btn"
                @click="viewSourceOrder"
                >查看比价单列表>></a
              >
              <a
                href="javascript:;"
                class="emc-all-submit-order"
                @click="initiateInquiry"
                >发起比价</a
              >
            </template>
            <a
              href="javascript:;"
              class="emc-all-submit-order"
              @click="
                e => {
                  isInquiry = false;
                  submitOrder(e);
                }
              "
              >提交订单</a
            >
          </div>
        </div>
        <!--总和End-->
      </div>
      <!--总和Fix Begin-->
      <div class="emc-all-total-fix" v-show="emcTotalFixDefault">
        <!--:style="{ display: emcTotalFix ? 'block' : 'none' }"-->
        <div class="emc-all-total">
          <div class="emc-all-total-l clearfix">
            <label>
              <el-checkbox
                class="emc-checkbox"
                style="padding-right: 19px"
                :indeterminate="checkedEmcAll.isIndeterminate['isIndeter']"
                v-model="checkedEmcAll.selectedData['isChecked']"
                @change="handleCheckAllEmcChange"
              ></el-checkbox>
              全选
            </label>
            <span class="disabledFixCheckbox" v-if="!isCheckedState"></span>
            <a href="javascript:;" @click="deletedEmcGoods()">删除选中商品</a>
            <a href="javascript:;" @click="removeEmcGoods()">移到我的关注</a>
          </div>
          <div class="emc-all-total-r clearfix">
            <div class="emc-all-total-r-slected">
              已选商品<span>{{ selectGoodsNumAndCar }}</span
              >种
            </div>
            <div class="emc-all-total-r-slected-title">
              <span class="emc-all-total-r-slected-title-h2"
                >总计（不含运费）</span
              ><span class="emc-all-total-r-slected-title-p"
                >￥{{ selectGoodsTotalPriceAndCar | toMoneyFormat }}</span
              >
              <div
                v-if="selectemcGoodsTotalDisPrice"
                class="emc-all-total-r-slected-attr"
              >
                促销：-￥{{ selectemcGoodsTotalDisPrice | toMoneyFormat }}
              </div>
            </div>
            <template v-if="isHasSeekPermission">
              <!-- <a
                v-if="!hasSeek"
                href="javascript:;"
                class="emc-all-submit-order"
                @click="initiateInquiry"
                >发起比价</a
              >
              <a
                v-else
                href="javascript:;"
                class="emc-all-submit-order"
                @click="viewSourceOrder"
                >查看寻源单</a
              > -->
              <a
                v-if="hasSeek"
                href="javascript:;"
                class="bijia-btn"
                @click="viewSourceOrder"
                >查看比价单列表>></a
              >
              <a
                href="javascript:;"
                class="emc-all-submit-order"
                @click="initiateInquiry"
                >发起比价</a
              >
            </template>
            <a
              href="javascript:;"
              class="emc-all-submit-order"
              @click="
                e => {
                  isInquiry = false;
                  submitOrder(e);
                }
              "
              >提交订单</a
            >
          </div>
        </div>
      </div>

      <sameGoods
        ref="sameGoods"
        @success="handleAdd"
        :defaultArea="defaultArea"
      />
      <fledNav ref="cart" />
    </div>
    <div class="ccui-home-index" v-else>
      <div class="emc-container">
        <div style="width: 100%">
          <div class="emc-top clearfix row">
            <div class="emc-title">商城商品({{ emcGoodsNumAndCar }})</div>
            <div
              class="emc-title-no-active"
              @click="goInquiryPricePage"
              style="margin-left: 15px;"
            >
              询价商品
            </div>
          </div>
        </div>
        <NoContent v-if="flagIsNoContent" />
      </div>
      <fledNav ref="cart" />
    </div>
    <!-- 快速清理弹窗 -->
    <clear-goods ref="clearGoods" @clear="handleClear" />
    <!-- 商品是否冻结弹窗 -->
    <frozenGoods ref="frozenGoods" />
    <!-- 撮合弹窗 -->
    <noTiceDialog
      v-model="noTiceValue"
      :shopNames="noShopNames"
      @confirm="handleSelected(1)"
      ref="noTiceRef"
    />
  </div>
</template>

<script>
import {
  viewProvince,
  qryAddress,
  // queryCarts,
  queryCartsByPage,
  selected,
  deleteSku,
  modifyNumTotal,
  qryDefault,
  qryUnitOrgTree,
  querySkuAccurateComparisonMapBySkuNewId,
  addCart,
  moveToMyFocusFromCart,
  querySkuTagConfigDetail,
  qrySeekPermission
} from "@/api/emc-api";
import { getCartList, delCarCart, updateCarCart } from "@/api/car";
import Cookies from "js-cookie";
import {
  addUrlPerFix
  // debounce
} from "@/utils";
import NoContent from "@/components/noContent";
import UnitSelect from "./components/unitSelect/index.vue";
import sameGoods from "./components/sameGoods.vue";
import noTiceDialog from "./components/noTiceDialog.vue";
import clearGoods from "@/components/clear-goods.vue";
import frozenGoods from "@/components/frozenGoods.vue";
import Tag from "./components/tag/new-goods-tag.vue";
import fledNav from "./components/fled-nav.vue";
import { isdisabled } from "@/filters/index.js";
import { Emccompute } from "@/utils/emc-compute.js";
// import carList from "./mock";
const VUE_APP_EMI_URL = addUrlPerFix(process.env.VUE_APP_EMI_URL);
const VUE_APP_EMS_URL = addUrlPerFix(process.env.VUE_APP_EMS_URL);
const placeAnOrderUrl = addUrlPerFix(process.env.VUE_APP_PLACE_AN_ORDER_URL);
const purchaseInquiry = addUrlPerFix(process.env.VUE_APP_PURCHASE_INQUIRY_URL);
const VUE_APP_EMPO_URL = addUrlPerFix(process.env.VUE_APP_EMPO_URL);
const VUE_APP_CLZL_URL = addUrlPerFix(process.env.VUE_APP_CLZL_URL);
const VUE_APP_MOA_URL = addUrlPerFix(process.env.VUE_APP_MOA_URL);
export default {
  name: "emc-home",
  components: {
    NoContent,
    UnitSelect,
    Tag,
    sameGoods,
    fledNav,
    clearGoods,
    frozenGoods,
    noTiceDialog
  },
  data() {
    return {
      carList: [],
      isAddressOne: true,
      isNoContent: false,
      flagIsNoContent: false,
      access_token: Cookies.get("access_token"),
      minHeight: "auto",
      clientHeight: 0,
      emcTotalFixDefault: false,
      emcTotalFix: false,
      emcTotalOffTop: 0,
      isCheckedState: false, // 判断是否可以选中  每次选中加载完后可再次进行选中
      getAddressUrl:
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) +
        "/apis/emc/cart/qryAddressOfFourth",
      isdisabled: isdisabled,
      leftPlace: "right",
      paramsData: "100108",
      VUE_APP_EMS_URL: VUE_APP_EMS_URL,
      goodsDetailUrl: VUE_APP_EMI_URL,
      dialogVisible: false,
      isBlurFinish: true, // 数量失焦事件是否完成
      currClick: 0, // 1 当前点击为提交订单模块
      isNumChange: false, // 改变数量是否成功
      defaultAreaFix: [
        { code: 1, name: "北京市" },
        { code: 2802, name: "东城区" },
        { code: 2821, name: "内环到三环里" }
      ],
      defaultArea: [],
      selectCity: [],
      emcGoodsNum: 0,
      selectemcGoodsNum: 0, //已选择商品总数量
      selectemcGoodsTotalPrice: 0, // 已选择商品的总价格
      selectemcGoodsTotalDisPrice: 0, //已选商品总优惠
      checkedEmcAll: {
        //购物车全选
        selectedData: { isChecked: false }, //购物车中是否全部勾选商品
        isIndeterminate: { isIndeter: false } //购物车中半选状态
      },
      objAllNum: {},
      checkedForm: {
        //已勾选的商品
        selectedData: {}
      },
      checkedShopAll: {
        //店铺中是否全部勾选商品
        selectedData: {},
        //店铺的半选状态
        isIndeterminate: {}
      },
      checkedShopGoods: {
        //店铺中所有的商品
        goodsData: {}
      },
      checkedEmcGoods: {
        // 购物车中所有商品
        goodsData: {}
      },
      tableWidth: {
        selection: 42,
        goodsName: 520,
        goodsName1: 300,
        invoiceSubject: 245,
        goodsPrice: 136,
        goodsNum: 160,
        goodsTotal: 170,
        op: 114
      },
      emcGoodsListData: [],
      invalidGoodsListData: [],
      // 分页相关参数
      pageNum: 1, // 当前页码
      pageSize: 5, // 每页数据条数
      totalPage: 1, // 总页数
      pageLoading: false, // 页面加载状态
      noMoreData: false, // 是否没有更多数据
      scrollListener: null, // 滚动监听器
      addressOptions: [],
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          if (level === 0) {
            // 第一级加载省份
            viewProvince({})
              .then(res => {
                if (res.data.code === "0") {
                  const nodes = res.data.data.map(item => {
                    return {
                      label: item.addressAbbr,
                      value: item.addressCode,
                      leaf: false
                    };
                  });
                  resolve(nodes);
                }
              })
              .catch(e => {
                console.log(e);
              });
          } else {
            qryAddress({ addressCode: node.value })
              .then(res => {
                if (res.data.code === "0") {
                  const nodes = res.data.data.map(item => {
                    return {
                      label: item.addressAbbr,
                      value: item.addressCode,
                      leaf: item.lastFlag
                    };
                  });
                  resolve(nodes);
                }
              })
              .catch(e => {
                console.log(e);
              });
            console.log("sd");
          }
        }
      },
      unitSelectData: [],
      purchaseOrgId: "",
      purchaseUndertakeOrgIdValue: "",
      isMonofile: false,
      isFlag: true,
      addCardStatus: [1, 5, 7, 8],
      checkList: [],
      backCartCartNum: 2,
      requestedLowMap: {}, // 已经请求过同款低价的sku
      requestedLabelMap: {}, // 已经请求过商品标签的sku
      isInquiry: false, //是否点击发起比价按钮
      seekId: null, //询价单id
      hasSeek: null, //是否已询价
      isHasSeekPermission: null, //是否有询价权限
      noTiceValue: false, //撮合弹窗显示隐藏
      noShopNames: "" //撮合弹窗店铺名称
    };
  },

  beforeRouteLeave(to, form, next) {
    Cookies.remove("backCartCartData");
  },
  computed: {
    // 车辆租赁全选半联动状态
    allCarIndeterminate() {
      return (
        this.carList.length > 0 &&
        this.carList.some(item => item.selected) &&
        !this.carList.every(item => item.selected)
      );
    },
    // 车辆租赁全选状态
    selectAllCar() {
      return (
        this.carList.length > 0 && this.carList.every(item => item.selected)
      );
    },
    selectCarList() {
      return this.carList.filter(v => v.selected);
    },
    // 勾选的商城商品总数量+车辆租赁数量
    selectGoodsNumAndCar() {
      const { selectemcGoodsNum, selectCarList } = this;
      const carGoodsNum = selectCarList.length;
      return selectemcGoodsNum + carGoodsNum;
    },
    // 商城商品总数量+车辆租赁数量
    emcGoodsNumAndCar() {
      return this.emcGoodsNum + this.carList.length;
    },
    // 勾选的商城商品总价+车辆租赁总价
    selectGoodsTotalPriceAndCar() {
      const { selectemcGoodsTotalPrice, selectCarList } = this;
      const carPriceTotal = selectCarList.reduce((a, b) => {
        return a + b.totalAmount;
      }, 0);
      return selectemcGoodsTotalPrice + carPriceTotal;
    }
  },
  mounted() {
    document.title = "我的购物车 - 中交云采";
    if (sessionStorage.getItem("userInfo")) {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      const token = userInfo.userToken;
      if (!token) {
        this.$store.commit("SET_IS_SHOW_DIALOG", true);
      }
    }

    if (Number(this.backCartCartNum) === 1) {
      if (Cookies.get("formCartSelect")) {
        let formCartSelectData = JSON.parse(Cookies.get("formCartSelect"));
        Cookies.set("backCartCartData", JSON.stringify(formCartSelectData), {
          path: "/",
          domain: "iccec.cn"
        });
      }
    }

    if (!Cookies.get("backCartCartData")) {
      Cookies.set("backCartCartNum", 2, {
        path: "/",
        domain: "iccec.cn"
      });
    }
    this.backCartCartNum = Number(Cookies.get("backCartCartNum"));
    if (Number(this.backCartCartNum) !== 1) {
      Cookies.remove("backCartCartData", {
        path: "/",
        domain: "iccec.cn"
      });
    } else {
      if (Cookies.get("formCartSelect")) {
        let formCartSelectData = JSON.parse(Cookies.get("formCartSelect"));
        Cookies.set("backCartCartData", JSON.stringify(formCartSelectData), {
          path: "/",
          domain: "iccec.cn"
        });
      }
    }

    // let IPCodeList = Cookies.get("IPCodeList");
    // if (IPCodeList) {
    //   this.defaultAreaFix = JSON.parse(IPCodeList);
    //   this.defaultArea = JSON.parse(JSON.stringify(this.defaultAreaFix));
    //   this.getQuerCartsAll(true);
    // } else {
    //   this.defaultAreaFix = [
    //     {
    //       name: "北京",
    //       code: 1
    //     },
    //     {
    //       name: "朝阳区",
    //       code: 72
    //     },
    //     {
    //       name: "三环以内",
    //       code: 2799
    //     }
    //   ];
    //  // this.GetQryDefault();
    // }

    this.getInfoTree();
    this.getCartList();
    this.initClearGoods();
    //  this.GetQryDefault();
    window.addEventListener("scroll", this.handleScrollx, true);
    // window.onresize = this.handleScrollx

    if (document.documentElement.clientWidth > 1280) {
      this.tableWidth = {
        selection: 42,
        goodsName: 520,
        goodsName1: 300,
        invoiceSubject: 245,
        goodsPrice: 136,
        goodsNum: 160,
        goodsTotal: 170,
        op: 114
      };
    } else {
      this.tableWidth = {
        selection: 42,
        goodsName: 430,
        goodsName1: 255,
        invoiceSubject: 200,
        goodsPrice: 106,
        goodsNum: 160,
        goodsTotal: 170,
        op: 114
      };
    }
  },
  methods: {
    initClearGoods() {
      this.$nextTick(() => {
        this.$refs.clearGoods.init();
      });
    },
    handleClear() {
      this.getQuerCartsAll(false); //全部刷新商品列表
    },
    goCarDetail({ uid, rentalDurationMonths, cityId }) {
      window.open(
        `${VUE_APP_CLZL_URL}/detail/${uid}?dataNum=${rentalDurationMonths}&cityId=${cityId}`
      );
    },
    updateCarCart(val, item, index) {
      if (item.isAvailable == 0) {
        // this.$set(this.carList[index], "rentalNum", item.rentalNumOrigin);
        return this.$message({
          showClose: true,
          message: "该商品已下架，请重新选择",
          type: "error",
          ccuiCustom: true
        });
      }
      item.selected = true;
      updateCarCart({ id: item.id, rentalNum: val })
        .then(res => {
          if (res.data.code === "0") {
            this.getCartList();
          }
        })
        .catch(() => {
          item.rentalNum = item.rentalNumOrigin;
        });
    },
    getCartList() {
      const selectCarIds = this.selectCarList.map(v => v.id);
      getCartList({
        // createBy: JSON.parse(localStorage.getItem("userInfo")).openId
      }).then(res => {
        if (res.data.code === "0") {
          const { carCartPageList = [] } = res.data.data || {};
          this.carList = carCartPageList.map((v, i) => {
            v.selected = selectCarIds.includes(v.id);
            v.rentalNumOrigin = v.rentalNum;
            // if (i == 1) {
            //   v.isAvailable = 0
            // }
            return v;
          });
        }
      });
    },
    // 车辆全选反选
    changeAllCar(val) {
      this.carList = this.carList.map(v => {
        if (v.isAvailable == 1) {
          v.selected = val;
        }
        return v;
      });
    },
    // 车辆单个选择
    changeCar(val, item, index) {},
    // 删除车辆
    deletedCar(row) {
      // 单个删
      if (row) {
        this.delCarCart(row, true);
      } else {
        // 删除选中 循环调删除
        this.selectCarList.forEach((v, i) => {
          this.delCarCart(v, i == this.selectCarList.length - 1);
        });
      }
    },
    delCarCart(row, isRefresh = false) {
      delCarCart({
        // createBy: JSON.parse(localStorage.getItem("userInfo")).openId,
        id: row.id
      }).then(res => {
        if (res.data.code === "0") {
          isRefresh && this.getCartList();
        }
      });
    },
    goInquiryPricePage() {
      location.href = location.origin + `/inquiry-price-goods/index`;
    },
    async handleAdd(row) {
      const checkNumdata = {
        provinceCode: this.defaultArea[0].code + "",
        cityCode: this.defaultArea[1].code + "",
        countyCode: this.defaultArea[2].code + ""
      };
      const tempBuyCarData = {
        isShowLoading: true,
        skuId: row.skuId,
        num: row.num,
        notCheckStock: false,
        area:
          checkNumdata.provinceCode +
          "_" +
          checkNumdata.cityCode +
          "_" +
          checkNumdata.countyCode
      };
      await addCart(tempBuyCarData);
      this.getQuerCartsAll(true);
    },
    getLableItem(item2) {
      const { code } = item2;
      const obj1 = this.requestedLowMap[code];
      const tagList = this.requestedLabelMap[code];
      return {
        ...item2,
        isLower: obj1?.isLower || 0,
        tagList: tagList || []
      };
    },
    getLowerStatus({ code }) {
      const item2 = this.requestedLowMap[code] || {};
      return !item2.isLower && item2.rows && item2.rows.length > 0;
    },
    querySkuAccurateComparisonMapBySkuNewId(list) {
      return new Promise((resolve, reject) => {
        const skuIds = list.reduce((a, b) => {
          return a.concat(b.sons.map(v => v.code));
        }, []);
        console.log("skuIds", skuIds);
        const filterSkuIds = skuIds.filter(v => !this.requestedLowMap[v]);
        if (filterSkuIds.length == 0) return;
        const obj = {
          // skuIds: [30073234],
          skuIds: filterSkuIds,
          provinceCode: this.defaultArea[0].code,
          cityCode: this.defaultArea[1].code,
          countyCode: this.defaultArea[2].code,
          streetCode:
            this.defaultArea.length > 3 ? this.defaultArea[3].code : "0",
          purchaseOrgId: this.purchaseOrgId
        };
        querySkuAccurateComparisonMapBySkuNewId(obj).then(res => {
          if (res.data.code === "0") {
            skuIds.forEach(v => {
              if (!this.requestedLowMap[v]) {
                this.requestedLowMap[v] = {};
              }
            });
            const data = res.data.data.skuMap || {};
            const arr = list.map(item => {
              item.sons = item.sons.map(v => {
                if (data[v.code]) {
                  v = { ...v, ...data[v.code] };
                  this.requestedLowMap[v.code] = v;
                }
                return v;
              });
              return item;
            });
            this.$forceUpdate();
            // this.emcGoodsListData = arr;
            resolve(arr);
          }
        });
      });
    },
    querySkuTagConfigDetail(list) {
      const skuIds = list.reduce((a, b) => {
        return a.concat(b.sons.map(v => v.code));
      }, []);
      const filterSkuIds = skuIds.filter(v => !this.requestedLabelMap[v]);
      if (filterSkuIds.length == 0) return;

      querySkuTagConfigDetail({ skuIds: filterSkuIds }).then(res => {
        let firstMap = res.data.data.tagMap || {};
        let tagOfActivityIdMap = res.data.data.tagOfActivityIdMap || {};

        skuIds.forEach(v => {
          if (!this.requestedLabelMap[v]) {
            this.requestedLabelMap[v] = [];
          }
        });
        list.forEach(i => {
          i.sons.forEach(item => {
            let skuIdStr = item.code.toString();
            const tagList = [];
            const tag1 = firstMap[skuIdStr];
            const tag2 = tagOfActivityIdMap[skuIdStr];

            if (tag1) {
              tagList.push(tag1);
            }
            if (tag2) {
              tag2.sort(
                (a, b) =>
                  new Date(b.activityOffTime).getTime() -
                  new Date(a.activityOffTime).getTime()
              );
              tagList.push(...tag2);
            }
            if (tagList.length > 5) {
              tagList.length = 5;
            }
            if (tagList.length > 0) {
              this.requestedLabelMap[skuIdStr] = tagList;
            }
            // this.$set(item, "tagList", tagList);
            this.$forceUpdate();
          });
        });
      });
    },
    showModal(code) {
      const obj = {
        skuIds: [code],
        provinceCode: this.defaultArea[0].code,
        cityCode: this.defaultArea[1].code,
        countyCode: this.defaultArea[2].code,
        streetCode:
          this.defaultArea.length > 3 ? this.defaultArea[3].code : "0",
        purchaseOrgId: this.purchaseOrgId,
        isShowLoading: true
      };
      querySkuAccurateComparisonMapBySkuNewId(obj).then(res => {
        if (res.data.code == "0") {
          const { skuMap = {} } = res.data.data || {};
          if (skuMap[code]) {
            this.$refs.sameGoods.showModal(skuMap[code].rows);
          } else {
            this.$message({
              message: "暂无数据",
              type: "error",
              ccuiCustom: true,
              showClose: true
            });
          }
        }
      });
    },
    getShopName(shopType) {
      console.log(this.shopTypeDataObjMap.shopCategorySelf, 1111111111111111);
      return this.shopTypeDataObjMap.shopCategorySelf[shopType];
    },
    copyInvoiceSubject(item) {
      var cInput = document.createElement("input");
      cInput.value = item.businessName;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand("copy");
      this.$message({
        message: "复制成功",
        type: "success",
        ccuiCustom: true,
        showClose: true
      });
    },
    qrySeekPermission() {
      qrySeekPermission({
        purchaseOrgId: this.purchaseOrgId
        // isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.isHasSeekPermission = res.data.data.hasSeekPermission;
        }
      });
    },
    async GetQryDefault() {
      try {
        // 请求默认地址
        await qryDefault({
          // isShowPageLoading: true
        })
          .then(res => {
            if (res.data.code === "0") {
              this.$nextTick(() => {
                this.isAddressOne = false;
              });
              if (this.isAddressOne) {
                if (Cookies.get("IPCodeList")) {
                  this.defaultAreaFix = JSON.parse(Cookies.get("IPCodeList"));
                  this.defaultArea = Object.assign(this.defaultAreaFix);
                } else {
                  this.defaultAreaFix = res.data.data;
                  this.defaultArea = Object.assign(this.defaultAreaFix);
                }
              }
            }
            // if (res.data.code === "0" && res.data.data && res.data.data.length > 0) {
            //   this.defaultAreaFix = res.data.data;
            // }
            // this.defaultArea = JSON.parse(JSON.stringify(this.defaultAreaFix));
          })
          .catch(e => {
            console.log(e);
            this.defaultArea = JSON.parse(JSON.stringify(this.defaultAreaFix));
          });
        await this.getQuerCartsAll(true);
      } catch (err) {
        console.log(err);
      }
    },
    /**
     * 获取购物车所有数据
     * @param {boolean} isloading - 是否显示页面加载状态
     * @description 获取购物车数据的入口方法，重置分页参数并调用loadCartData加载数据
     */
    getQuerCartsAll(isloading) {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        // 判断是ie浏览器
        this.emcTotalFixDefault = false;
        this.emcTotalFix = false;
      }
      try {
        // 重置分页参数
        this.pageNum = 1;
        this.noMoreData = false;

        // 调用通用的加载购物车数据方法
        this.loadCartData(isloading, true);
      } catch (e) {
        this.pageLoading = false;
        this.isCheckedState = true;
        console.log(e);
      }
    },

    /**
     * 通用的加载购物车数据方法
     * @param {boolean} isloading - 是否显示页面加载状态
     * @param {boolean} isFirstLoad - 是否为首次加载，默认为false
     */
    loadCartData(isloading, isFirstLoad = false) {
      // isloading && (this.pageLoading = true);
      this.pageLoading = true;

      queryCartsByPage({
        isShowPageLoading: isloading,
        provinceCode: this.defaultArea[0].code,
        cityCode: this.defaultArea[1].code,
        countyCode: this.defaultArea[2].code,
        townCode: this.defaultArea.length > 3 ? this.defaultArea[3].code : "0",
        purchaseOrgId: this.purchaseOrgId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
        .then(async res => {
          this.pageLoading = false;
          if (res.data.code === "0") {
            let newData;

            if (isFirstLoad) {
              // 首次加载处理
              res.data.data = res.data.data.queryEmcS;
              this.emcGoodsNum = res.data.data.countCartItem;
              newData = res.data.data.sons;
              this.emcGoodsListData = newData;

              // 计算总页数
              this.totalPage = Math.ceil(this.emcGoodsNum / this.pageSize);

              this.flagIsNoContent = true;

              this.selectemcGoodsNum = res.data.data.selectedSkuNum; //已选总商品种类
              this.selectemcGoodsTotalPrice = res.data.data.afterPromotionPrice; //总优惠后价格
              this.selectemcGoodsTotalDisPrice =
                res.data.data.selectSkuPromotionPrice; //总优惠

              // 失效商品先用别的商品顶一下
              this.invalidGoodsListData = res.data.data.skuList;
            } else {
              // 加载更多处理
              newData = res.data.data.queryEmcS.sons;

              // 合并数据
              if (newData.length > 0) {
                this.emcGoodsListData = [...this.emcGoodsListData, ...newData];
              }
            }
            // 获取seekId
            this.seekId = res.data.data.seekId;
            // 获取hasSeek 是否询价
            this.hasSeek = res.data.data.hasSeek;

            // 判断是否还有更多数据
            if (newData.length === 0 || this.pageNum >= this.totalPage) {
              this.noMoreData = true;
            }

            if (newData.length > 0) {
              // 处理商品比价和标签
              this.querySkuAccurateComparisonMapBySkuNewId(newData);
              this.querySkuTagConfigDetail(newData);

              // 购物车中所有skuis集合
              this.checkedEmcGoods.goodsData[
                "all"
              ] = Emccompute.queryShopAllGoodsCode([], this.emcGoodsListData);

              // 更新选中状态
              if (isFirstLoad) {
                this.emcGoodsListDataFilter(this.emcGoodsListData);
              } else {
                this.emcGoodsListDataFilter(newData);
              }
            }

            // 添加滚动监听
            this.addScrollListener();
          } else {
            this.emcGoodsListData = [];
            this.invalidGoodsListData = [];
          }
          this.isCheckedState = true;

          this.$nextTick(() => {
            this.minHeight = `${document.documentElement.clientHeight -
              206 -
              456}px`;
            this.clientHeight = document.documentElement.clientHeight;
            if (document.getElementById("emc-all-total")) {
              this.emcTotalOffTop =
                document.getElementById("emc-all-total").offsetTop + 238;
            }

            this.handleScrollx(1);
          });
        })
        .catch(e => {
          this.pageLoading = false;
          this.isCheckedState = true;
          console.log(e);
        });
    },

    /**
     * 加载更多数据
     * 当滚动到页面底部时触发，增加页码并加载下一页数据
     */
    loadMoreData() {
      if (this.pageLoading || this.noMoreData) return;

      this.pageNum += 1;

      // 调用通用的加载购物车数据方法，isFirstLoad设为false表示加载更多
      this.loadCartData(false, false);
    },

    /**
     * 添加滚动监听
     * 用于监听页面滚动事件，实现触底加载更多功能
     */
    addScrollListener() {
      // 移除之前的监听器
      if (this.scrollListener) {
        window.removeEventListener("scroll", this.scrollListener);
      }

      // 添加新的监听器
      // this.scrollListener = this.handleScroll.bind(this);
      // this.scrollListener = debounce(this.handleScroll, 500).bind(this);
      // window.addEventListener("scroll", this.scrollListener);
    },

    /**
     * 处理滚动事件
     * 当页面滚动到底部附近时，触发加载更多数据
     */
    handleScroll() {
      console.log("scrollListener");
      // 如果正在加载或没有更多数据，则不处理
      if (this.pageLoading || this.noMoreData) return;

      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;

      // 当滚动到距离底部100px时，加载更多数据
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        console.log("scrollListener loadMoreData");
        this.loadMoreData();
      }
    },

    getAddressOf(cityValue) {
      let [pcode, cityName] = [[], []];
      cityValue.forEach(i => {
        pcode.push(i.code);
        cityName.push(i.name);
      });
      Cookies.set("IPCodeList", cityValue, { path: "/", domain: "iccec.cn" });
      // 购物车业务
      this.defaultArea = cityValue;
      this.getQuerCartsAll(true);
    },
    emcGoodsListDataFilter(data) {
      data.forEach(res => {
        if (res.type === 2) {
          this.checkedForm.selectedData[
            res.code
          ] = Emccompute.queryShopSelectedGoodsCode([], res.sons); // 已选择的商品code
          this.checkedShopAll.selectedData[res.code] = false;
          this.checkedShopAll.isIndeterminate[res.code] = false;
          this.checkedShopGoods.goodsData[
            res.code
          ] = Emccompute.queryShopAllGoodsCode([], res.sons);
          // 判断店铺中可选商品是否为0 lqz测试
          if (this.checkedShopGoods.goodsData[res.code].length === 0) {
            res.shopdisabled = true;
          } else {
            res.shopdisabled = false;
          }
          this.judgeShopCheckAll(res.code); //判断店铺是否全选
          this.judgeShopIsIndeter(res.code); // 判断店铺是否半选
        }
      });
      // 未解决计数器问题搞一个对象存储
      this.objAllNum = Emccompute.queryAllNum({}, data);
      // 判断是否全选
      console.log(this.objAllNum);
      this.judgeEmcCheckAll(); //判断购物车是否全选
      this.judgeEmcIsIndeter(); //判断购物车是否半选
      //  this.getSelectemcGoodsTotal();//获取购物车总数量及价格
    },
    handleCheckedGoods(shopCode) {
      // 更改单个商品选中或加减数量 前端综合判断选中状态
      let obj = JSON.parse(JSON.stringify(this.checkedForm.selectedData));
      this.$set(this.checkedForm, "selectedData", obj);
      this.judgeShopCheckAll(shopCode); //判断店铺是否全选
      this.judgeShopIsIndeter(shopCode); // 判断店铺是否半选
      this.judgeEmcCheckAll(); //判断购物车是否全选
      this.judgeEmcIsIndeter(); //判断购物车是否半选
    },
    handleCheckedGoodsChange(val, shopCode) {
      //店铺下商品选中
      // this.emcGoodsListData[index1].sons.splice(index2, 1, row); //更新选中状态
      this.handleCheckedGoods(shopCode);
      //  this.getSelectemcGoodsTotal();//获取购物车总数量及价格
      this.handleSelected();
    },
    handleCheckAllShopChange(val, code) {
      //这里code是店铺级别code
      if (val) {
        this.checkedForm.selectedData[code] = this.checkedShopGoods.goodsData[
          code
        ]; /**把店铺中所有商品赋值**/
      } else {
        this.checkedForm.selectedData[code] = [];
      }
      let obj = JSON.parse(JSON.stringify(this.checkedForm.selectedData));
      this.$set(this.checkedForm, "selectedData", obj);

      //取消半选
      /*let obj2 = {};
      obj2[code] = false;
      this.$set(this.checkedShopAll, "isIndeterminate", obj2);*/
      this.checkedShopAll.isIndeterminate[code] = false;

      // 店铺中全选
      this.judgeEmcCheckAll(); //判断购物车是否全选
      this.judgeEmcIsIndeter(); //判断购物车是否半选
      //this.getSelectemcGoodsTotal();//获取购物车总数量及价格
      this.handleSelected();
    },
    handleCheckAllEmcChange(val) {
      // 全选购物车中商品
      let selectedAllData = this.checkedForm.selectedData;
      if (val) {
        for (let i of Object.keys(selectedAllData)) {
          selectedAllData[i] = JSON.parse(
            JSON.stringify(this.checkedShopGoods.goodsData)
          )[i];
          if (selectedAllData[i].length === 0) {
            this.checkedShopAll.selectedData[i] = false;
            this.checkedShopAll.isIndeterminate[i] = false;
          } else {
            this.checkedShopAll.selectedData[i] = true;
            this.checkedShopAll.isIndeterminate[i] = false;
          }
        }
      } else {
        for (let i of Object.keys(selectedAllData)) {
          selectedAllData[i] = [];
          this.checkedShopAll.selectedData[i] = false;
          this.checkedShopAll.isIndeterminate[i] = false;
        }
      }
      // 全选操作取消所有半选
      this.$set(this.checkedEmcAll, "isIndeterminate", { isIndeter: false });
      this.handleSelected();
      // 全选反选车辆租赁
      this.changeAllCar(val);
    },
    handleSelected(rank) {
      //购物车选中商品
      let obj = {
        skuIds: this.selectedItems()
      };
      this.isCheckedState = false;
      if (rank && rank === 1) {
        obj.isShowLoading = true;
      }
      selected(obj)
        .then(res => {
          if (res.data.code === "0") {
            if (rank && rank === 1) {
              // 提交走一遍选中接口不必要刷购物车页面
              //提交时触发要跳转页面
              // window.location.href = placeAnOrderUrl;
              if (this.isFlag) {
                if (this.isInquiry) {
                  window.location.href =
                    this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
                    "?CLIENT_ID=100110&CALLBACK_URL=" +
                    encodeURIComponent(purchaseInquiry + "?sourceSystem=0");
                } else {
                  window.location.href =
                    this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
                    "?CLIENT_ID=100110&CALLBACK_URL=" +
                    encodeURIComponent(placeAnOrderUrl + "?");
                }
              }
            } else {
              this.getQuerCartsAll(false); //全部刷新商品列表
            }
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    selectedItems() {
      // 已选商品
      let [selectedSkus, selectedAllData] = [[], this.checkedForm.selectedData];
      for (let i of Object.keys(selectedAllData)) {
        selectedSkus.push.apply(selectedSkus, selectedAllData[i]);
      }
      return selectedSkus;
    },
    focusGoodsNum() {
      //当数量输入框获取焦点时
      this.isBlurFinish = false;
    },
    blurGoodsNum(e) {
      let that = this;
      setTimeout(() => {
        if (that.currClick === 0) {
          that.isBlurFinish = true;
        } else {
          that.currClick = 0;
        }
      }, 700);
      // this.isBlurFinish = true;
    },
    handleChangeGoodsNum(value, row, shopCode) {
      /**最大输入99999 超过给出提示**/
      if (value > 99999) {
        this.$message.closeAll();
        this.$message({
          message: "商品数量不能大于99999",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
        // 这里可以改成两种啊 一种还原 一种value
        value = row.num;
        this.$nextTick(function() {
          this.$set(this.objAllNum, row.code, value);
        });
        // 选中当前商品
        if (this.checkedForm.selectedData[shopCode].indexOf(row.code) === -1) {
          if (this.addCardStatus.includes(row.skuStatus)) {
            this.checkedForm.selectedData[shopCode].push(row.code);
          }
        }
        this.handleSelected();
        //this.getQuerCartsAll(false);
        return false;
      } else {
        if (
          row.maxPurchaseNum !== null &&
          row.maxPurchaseNum !== undefined &&
          row.maxPurchaseNum !== "" &&
          value > row.maxPurchaseNum
        ) {
          this.$message.closeAll();
          this.$message({
            message: `单次购买数量不能大于${row.maxPurchaseNum}`,
            type: "error",
            showClose: true,
            ccuiCustom: true
          });
          value = row.num; //还原最初的
          // value = row.maxPurchaseNum;
          this.$nextTick(function() {
            this.$set(this.objAllNum, row.code, value);
          });
          // 选中当前商品
          if (
            this.checkedForm.selectedData[shopCode].indexOf(row.code) === -1
          ) {
            if (this.addCardStatus.includes(row.skuStatus)) {
              this.checkedForm.selectedData[shopCode].push(row.code);
            }
          }
          this.handleSelected();
          return false;
        }
        this.$nextTick(function() {
          this.$set(this.objAllNum, row.code, value);
        });
        let area = `${this.defaultArea[0].code}_${this.defaultArea[1].code}_${this.defaultArea[2].code}`;
        let obj = {
          totalNum: value,
          skuId: row.code,
          area: area
        };
        this.isNumChange = false; // 操作数量改变
        this.isMonofile = true;
        modifyNumTotal(obj)
          .then(res => {
            if (res.data.code === "0") {
              /**操作数量即选中**/
              if (
                this.checkedForm.selectedData[shopCode].indexOf(row.code) === -1
              ) {
                if (this.addCardStatus.includes(row.skuStatus)) {
                  this.checkedForm.selectedData[shopCode].push(row.code);
                }
                this.handleCheckedGoods(shopCode); // 判断选中状态专用
              }
              if (row.skuStatus !== 10) {
                this.isNumChange = true; // 数量改变成功
                this.isBlurFinish = true; // 数量失焦事件已完成
                this.isMonofile = false;
              } else {
                // 单位限制
                this.isMonofile = true;
                this.isNumChange = false; // 数量改变成功
                this.isBlurFinish = false; // 数量失焦事件已完成
              }
              let iTime;
              let _this = this;
              clearTimeout(iTime);
              iTime = setTimeout(function() {
                //需要执行的事件
                _this.getQuerCartsAll(false); //改变数量刷新
              }, 360);
            }
          })
          .catch(e => {
            this.isNumChange = false; // 数量改变失败
            this.isBlurFinish = false; // 数量失焦事件未完成
            // 选中当前商品
            if (
              this.checkedForm.selectedData[shopCode].indexOf(row.code) === -1
            ) {
              if (this.addCardStatus.includes(row.skuStatus)) {
                this.checkedForm.selectedData[shopCode].push(row.code);
              }
            }
            this.handleSelected();
            this.getQuerCartsAll(false); //改变数量刷新
          });
      }
    },
    judgeShopCheckAll(shopCode) {
      // 判断店铺是否全选
      let obj = JSON.parse(JSON.stringify(this.checkedForm.selectedData));
      if (
        obj[shopCode].length ===
          this.checkedShopGoods.goodsData[shopCode].length &&
        obj[shopCode].length !== 0
      ) {
        this.checkedShopAll.selectedData[shopCode] = true;
      } else {
        this.checkedShopAll.selectedData[shopCode] = false;
      }
    },
    judgeShopIsIndeter(shopCode) {
      //判断店铺是否半选
      let obj = JSON.parse(JSON.stringify(this.checkedForm.selectedData));
      if (
        obj[shopCode].length ===
          this.checkedShopGoods.goodsData[shopCode].length ||
        obj[shopCode].length === 0
      ) {
        this.checkedShopAll.isIndeterminate[shopCode] = false;
      } else {
        this.checkedShopAll.isIndeterminate[shopCode] = true;
      }
    },
    judgeEmcCheckAll() {
      // 判断购物车是否全选
      let [selectedAllDataNum, selectedAllData] = [
        0,
        this.checkedForm.selectedData
      ];
      for (let i of Object.keys(selectedAllData)) {
        selectedAllDataNum += selectedAllData[i].length;
      }
      if (
        selectedAllDataNum !== 0 &&
        selectedAllDataNum === this.checkedEmcGoods.goodsData.all.length
      ) {
        this.$set(this.checkedEmcAll, "selectedData", { isChecked: true });
      } else {
        this.$set(this.checkedEmcAll, "selectedData", { isChecked: false });
      }
    },
    judgeEmcIsIndeter() {
      //判断购物车是否半选
      // selectedAllDataNum //已选择商品种类数量
      let [selectedAllDataNum, selectedAllData] = [
        0,
        this.checkedForm.selectedData
      ];
      for (let i of Object.keys(selectedAllData)) {
        selectedAllDataNum += selectedAllData[i].length;
      }
      if (
        selectedAllDataNum !== this.checkedEmcGoods.goodsData.all.length &&
        selectedAllDataNum !== 0
      ) {
        this.$set(this.checkedEmcAll, "isIndeterminate", { isIndeter: true });
      } else {
        this.$set(this.checkedEmcAll, "isIndeterminate", { isIndeter: false });
      }
    },
    /*getSelectemcGoodsTotal(){ // 获取总价格及购已选中商品种类
      let selectedAllDataNum = 0 //已选择商品种类数量
      let selectedAllData = this.checkedForm.selectedData;
      for (let i in selectedAllData) {
        selectedAllDataNum += selectedAllData[i].length;
      }
      this.selectemcGoodsNum = selectedAllDataNum

    },*/
    deletedEmcGoods() {
      // 删除所选购物车商品
      let obj = {
        skuIds: this.selectedItems()
      };
      // 初始化已选择的数据
      this.initCheckFrom();

      this.deleteBatchBefore(obj);
    },
    // 选中删除数量校验
    deleteBatchBefore(obj) {
      const count = obj.skuIds.length + this.selectCarList.length;

      if (count === 0) {
        this.$message.closeAll();
        this.$message({
          message: "请至少选择一件商品",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
        return false;
      }

      this.handleDeletedSku(obj);
      this.deletedCar();
    },
    removeEmcGoods() {
      // 移除所选购物车商品
      let obj = {
        skuIds: this.selectedItems()
      };
      console.log("移到我的关注", obj.skuIds);
      if (obj.skuIds.length == 0) {
        return this.$message({
          message: "请至少选择一件商品",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
      }
      this.handleRmoveSku(obj);
    },
    deletedCurr(row, pRow) {
      //删除失效的商品
      let obj = {
        skuIds: [row.code]
      };
      if (pRow) {
        this.checkedForm.selectedData[pRow.code].splice(
          this.checkedForm.selectedData[pRow.code].indexOf(row.code),
          1
        );
      }
      this.handleDeletedSku(obj);
    },
    removeCurr(row) {
      //移除当前行
      console.log("移到我的关注", row);
      let obj = {
        skuIds: [row.code]
      };
      this.handleRmoveSku(obj);
    },
    initCheckFrom() {
      // 初始化已选择的商品
      for (let i of Object.keys(this.checkedForm.selectedData)) {
        this.checkedForm.selectedData[i] = [];
      }
    },
    handleDeletedSku(obj) {
      if (obj.skuIds.length === 0) {
        this.$message.closeAll();
        // this.$message({
        //   message: '请至少选择一件商品',
        //   type: 'error',
        //   showClose: true,
        //   ccuiCustom: true
        // })
        return false;
      }
      deleteSku(obj)
        .then(res => {
          if (res.data.code === "0") {
            /*let myEvent = new Event('resize');
            window.dispatchEvent(myEvent);*/
            this.getQuerCartsAll(false);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    handleRmoveSku(obj) {
      moveToMyFocusFromCart({ ...obj, isShowLoading: true }).then(res => {
        if (res.data.code === "0") {
          this.$message({
            message: res.data.message,
            type: "success",
            showClose: true,
            ccuiCustom: true
          });
          this.getQuerCartsAll(false);
        }
      });
    },
    submitOrder(e, n) {
      const selectedSkus = this.selectedItems();
      // 车辆租赁商品不支持与其他商品一起下单
      if (selectedSkus.length > 0 && this.selectCarList.length > 0) {
        this.$message.closeAll();
        this.$message({
          message: "车辆租赁商品不支持与其他商品一起下单",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
        return;
      }
      // 提交车辆租赁商品
      if (
        !this.isInquiry &&
        selectedSkus.length === 0 &&
        this.selectCarList.length > 0
      ) {
        console.log("提交租赁商品");
        const ids = this.selectCarList.map(item => item.id).join(",");
        window.location.href =
          VUE_APP_EMPO_URL + `/car?ids=${encodeURIComponent(ids)}`;
        return;
      }

      // 原有商城商品提交逻辑
      if (Cookies.get("backCartCartData")) {
        let backCartCartData = JSON.parse(Cookies.get("backCartCartData"));
        Cookies.set("formCartSelect", JSON.stringify(backCartCartData), {
          path: "/",
          domain: "iccec.cn"
        });
      }

      Cookies.remove("backCartCartNum", {
        path: "/",
        domain: "iccec.cn"
      });

      let length = 0;
      for (const key in this.checkedForm.selectedData) {
        if (this.checkedForm.selectedData[key].length !== 0) {
          length = 1;
        }
      }
      if (length === 0) {
        this.isFlag = false;
      } else {
        this.isFlag = true;
      }
      // 之后需要限制一秒内不能提交
      if (e.target.className === "emc-all-submit-order") {
        this.currClick = 1;
      }
      if (this.isBlurFinish === false) {
        let that = this;
        if (n !== 2) {
          setTimeout(() => {
            that.submitOrder(e, 2);
            that.isBlurFinish = true; // 为防止submitOrder优先于改变数量接口
            that.isMonofile = true;
          }, 300);
        }
        this.currClick = 0; // 通不过都重置为0
        return false;
      }
      if (this.isBlurFinish === true && n === undefined) {
        // 提交订单
        this.submitLastOrder();
      } else if (this.isBlurFinish === true && this.isNumChange === true) {
        //提交订单
        if (!this.isMonofile) {
          this.submitLastOrder();
        } else {
          this.$message.closeAll();
          this.$message({
            message: "请至少选择一件商品",
            type: "error",
            showClose: true,
            ccuiCustom: true
          });
        }
      } else {
        this.currClick = 0; // 通不过都重置为0
      }
    },
    // 查看寻源单
    viewSourceOrder() {
      // let url = VUE_APP_MOA_URL + `/enquiry/enquiryLists/detail/${this.seekId}`;
      // window.open(url, "_blank");
      // 点击【查看比价单列表】页面新打开页面调整至我的订单》询比价_全部页签，仅展示MRO商城发起的比价单
      let url = VUE_APP_MOA_URL + `/enquiry/enquiryLists/all`;
      window.open(url, "_blank");
    },
    // 发起比价
    initiateInquiry(e) {
      if (this.selectCarList.length > 0) {
        this.$message.closeAll();
        this.$message({
          message: "车辆租赁商品不支持发起比价",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
        this.currClick = 0; // 通不过都重置为0
        return false;
      }
      this.isInquiry = true;
      this.submitOrder(e);
    },
    async submitLastOrder() {
      let selectedSkus = this.selectedItems();
      if (selectedSkus.length === 0) {
        this.$message.closeAll();
        this.$message({
          message: "请至少选择一件商品",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
        this.currClick = 0; // 通不过都重置为0
        return false;
      }
      let arr = [];
      let obj1 = {};
      selectedSkus.map(item => {
        this.emcGoodsListData.map(item1 => {
          item1.sons.map(item2 => {
            if (item2.code === item) {
              if (item1.shopType == 3) {
                obj1[item1.name] = true;
              }
              item2.shopType = item1.shopType; // 添加店铺类型
              item2.shopName = item1.name || ""; // 添加店铺名称
              arr.push(item2);
            }
          });
        });
      });
      // 提交询价商品中是否有询价中的商品
      // if (!this.isInquiry) {
      console.log("提selectedData", selectedSkus);
      console.log("emcGoodsListData", this.emcGoodsListData);
      selectedSkus.map(item => {
        this.emcGoodsListData.map(item1 => {
          item1.sons.map(item2 => {
            if (item2.code === item) {
              arr.push(item2);
            }
          });
        });
      });
      console.log("arr", arr);
      let seekArr = arr.filter(item => item.hasSeek == 1);
      let str = seekArr.map(item => {
        return `<div style="margin-bottom:5px;">商品名称《${
          item.name
        }》已发起比价，暂不支持${this.isInquiry ? "比价" : "下单"}！</div>`;
      });
      console.log("str", str);
      if (seekArr.length > 0) {
        this.$message.closeAll();
        this.$message({
          dangerouslyUseHTMLString: true,
          message: str.join(""),
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
        this.currClick = 0; // 通不过都重置为0
        return false;
      }
      // }
      if (selectedSkus.length > 300) {
        this.$message.closeAll();
        this.$message({
          message: "单次购买商品种类不能超过300种，请重新挑选。",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
        this.currClick = 0; // 通不过都重置为0
        return false;
      }
      try {
        // 校验商品变动
        await this.$refs.clearGoods.checkShopStatus(selectedSkus);
        // 校验商品冻结
        await this.$refs.frozenGoods.checkFrozenSkuInfos(selectedSkus);
      } catch (err) {
        console.log("err", err);
        this.currClick = 0; // 通不过都重置为0
        return false;
      }
      // 撮合商品
      const shopTypelist = Object.keys(obj1);
      if (shopTypelist.length > 0) {
        this.noShopNames = shopTypelist.join("，");
        this.noTiceValue = true;
        return false;
      }
      this.handleSelected(1);
    },
    handleScrollx(source) {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (!scrollTop && document.body.scrollHeight - this.clientHeight > 400) {
        this.emcTotalFixDefault = true;
        if (
          source === 1 &&
          (!!window.ActiveXObject || "ActiveXObject" in window)
        ) {
          // 判断是ie浏览器
          setTimeout(() => {
            this.emcTotalFixDefault = false;
          }, 200);
          setTimeout(() => {
            this.emcTotalFixDefault = true;
          }, 400);
        }
      }

      if (scrollTop && this.clientHeight + scrollTop <= this.emcTotalOffTop) {
        // this.emcTotalFix = true;
        this.emcTotalFixDefault = true;
      } else if (
        scrollTop &&
        this.clientHeight + scrollTop > this.emcTotalOffTop
      ) {
        // this.emcTotalFix = false;
        this.emcTotalFixDefault = false;
      }
    },
    getInfoTree() {
      qryUnitOrgTree({})
        .then(res => {
          if (res.data.code === "0") {
            this.unitSelectData = res.data.data.orgData;
            const orgInfoCookie = Cookies.get("orgInfo");
            if (orgInfoCookie && JSON.parse(orgInfoCookie).orgId) {
              const orgInfo = JSON.parse(orgInfoCookie);
              const orgId = orgInfo.orgId;
              this.unitSelectData = res.data.data.orgData.filter(item => {
                return item.orgId === orgId;
              });
              this.purchaseOrgId = orgId;
              this.purchaseUndertakeOrgIdValue = orgInfo.name;
            } else if (
              Cookies.get("backCartCartData") &&
              JSON.parse(Cookies.get("backCartCartData")).deptId &&
              this.backCartCartNum === 1
            ) {
              let dataArr = [JSON.parse(Cookies.get("backCartCartData"))];
              this.purchaseOrgId = dataArr[0].orgId;
              this.purchaseUndertakeOrgIdValue = dataArr[0].orgDeptName;
            } else {
              if (res.data.data.orgData.length > 0) {
                this.purchaseOrgId = res.data.data.orgData[0].child[0].orgId;
                this.purchaseUndertakeOrgIdValue =
                  res.data.data.orgData[0].child[0].orgDeptName;
              }
            }
          }
          this.GetQryDefault();
          this.qrySeekPermission();
          // this.getQuerCartsAll(true);
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScrollx, true);
    // 移除滚动监听器
    if (this.scrollListener) {
      window.removeEventListener("scroll", this.scrollListener);
    }
  }
};
</script>
<style lang="scss" scoped>
.bijia-btn {
  float: right;
  display: inline-block;
  margin: 27px 10px 18px 10px;
  color: #eb273f;
  font-size: 14px;
}
.row {
  // display: flex;
  // justify-content: space-between;
}
.flex {
  display: flex;
  float: right;
  padding-right: 21px;
}
.invoiceSubject {
  float: left;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.icon-shopingName {
  // box-sizing: border-box;
  padding: 0 6px;
  background: #fff;
  border: 1px solid #ff142f;
  border-radius: 2px;
  color: #ff142f;
  height: 18px;
  display: inline-block;
  text-align: center !important;
  line-height: 18px;
  font-size: 12px;
  float: left;
  margin-top: 10px;
  margin-right: 5px;
}
.shopName {
  display: block;
  max-width: 155px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  float: left;
}
.low-price-label {
  border-radius: 4px;
  border: 1px solid #34ac2c;
  font-size: 12px;
  padding: 1px 6px;
  color: #34ac2c;
  user-select: none;
  // margin-left: 15px;
  // margin-right: 10px;
}

.load-more-container {
  text-align: center;
  // padding: 15px 0;
  // margin-top: 20px;

  .loading-indicator {
    // padding-top: 20px;
    /deep/.el-loading-text {
      color: #909399;
      font-size: 13px;
    }
  }

  .no-more-data {
    color: #909399;
    font-size: 14px;
    margin-bottom: 15px;
    // padding-top: 20px;
  }
}
</style>
